import { render } from "./Popup.vue?vue&type=template&id=0e670254"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=0e670254&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__